<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{message}}</p>
</div>
<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>No
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" (click)="handleClick()">
    <mat-icon>check</mat-icon>Si
  </button>
</div>
